import { Component, DestroyRef, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { API, TagDTO } from '../../../services/api/api';
import { UtilService } from '../../../services/util.service';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../services/error.service';
import { NavigationService } from '@ngx-seatback/utils';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-tag-edit',
  templateUrl: './tag-edit.component.html',
  styleUrls: ['./tag-edit.component.scss'],
  standalone: false,
})
export class TagEditComponent implements OnInit {
  form = new UntypedFormGroup({
    Name: new UntypedFormControl('', [Validators.required]),
    Description: new UntypedFormControl('', []),
  });
  tag: TagDTO;
  tagId: number;
  loading: boolean;

  constructor(
    private api: API,
    public util: UtilService,
    private activatedRoute: ActivatedRoute,
    private errorHandler: ErrorService,
    private navService: NavigationService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.tag = null;
    this.tagId = null;
  }

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.tagId = params.tagID;
      this.refreshFromServer();
    });
    this.registerFormChangesListener();
  }

  updateForm() {
    this.Name.setValue(this.tag.name);
    this.Name.markAsTouched();
    this.Description.setValue(this.tag.description);
    this.Description.markAsTouched();
  }

  updateTagCall() {
    this.loading = true;
    if (!this.tag.id) {
      this.api
        .shared_Tag_createTag(this.tag)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.tag = data;
            this.navService.navigateToPoint(this.util.RoutingID.tags);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    } else {
      this.api
        .shared_Tag_editTag(this.tag)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.tag = data;
            this.navService.navigateToPoint(this.util.RoutingID.tags);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  private registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      this.tag.name = value;
    });
    this.Description.valueChanges.subscribe(value => {
      this.tag.description = value;
    });
  }

  private refreshFromServer() {
    this.loading = true;
    if (!this.tagId) {
      this.tag = new TagDTO();
      this.loading = false;
    } else {
      this.api
        .shared_Tag_getTag(this.tagId)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.tag = data;
            this.updateForm();
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  setColor($event: string) {
    if ($event) {
      const temp = $event.split('#');
      this.tag.color = temp[temp.length - 1];
    }
  }
}
